import { render, staticRenderFns } from "./modal-ver_aprobados.vue?vue&type=template&id=241a0f17&scoped=true"
import script from "./modal-ver_aprobados.vue?vue&type=script&lang=js"
export * from "./modal-ver_aprobados.vue?vue&type=script&lang=js"
import style0 from "./modal-ver_aprobados.vue?vue&type=style&index=0&id=241a0f17&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241a0f17",
  null
  
)

export default component.exports